import { ReactNode } from 'react';
import { Card, Divider, Stack } from '@mui/material';

type Props = {
  Header: ReactNode;
  Content: ReactNode;
};

export const IntegrationCard = (props: Props) => {
  const { Header, Content } = props;
  return (
    <Card sx={{ p: 2, flex: 1, width: '50%', maxWidth: '30rem' }}>
      <Stack direction="column" gap={1} sx={{ height: '100%' }}>
        <Stack direction="row" gap={2} alignItems="center" sx={{ color: 'text.secondary' }}>
          {Header}
        </Stack>
        <Divider sx={{ mb: 1 }} />
        {Content}
      </Stack>
    </Card>
  );
};
